import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Toolbar, Link } from '@mui/material';
import { TextField, IconButton, Autocomplete } from '@totalsoft/rocket-ui';
import Search from '@mui/icons-material/Search';
import Close from '@mui/icons-material/Close';
import DoneAll from '@mui/icons-material/DoneAll';

const FolderExternalChecksItemSummaryToolbarComponent = ({
  onFilterValueChanged,
  fullTextFilter,
  onResetFilters,
  onVerificationsClick,
  onVerificationSorterChanged,
  verificationSorterOptions,
  selectedVerificationOrder
}) => {
  const [t] = useTranslation();

  return (
    <Toolbar>
      <Grid container spacing={2}>
        <Grid item xs={6} marginTop={2}>
          <TextField
            id={'folder_decision_externalChecksCard_filters_fulltext'}
            fullWidth={true}
            name='fullTextFilter'
            value={fullTextFilter}
            onChange={onFilterValueChanged}
            placeholder={t('Placeholders.ManualVerificationSearch')}
            startAdornment={<Search />}
            endAdornment={
              <IconButton
                onClick={onResetFilters}
                id={'folder_decision_externalChecksCard_filters_resetBtn'}
                tooltip={t('Tooltips.ResetFilters')}
                variant='text'
              >
                <Close />
              </IconButton>
            }
          />
        </Grid>
        <Grid item xs={3}>
          <Autocomplete
            id={'verificationSorter'}
            label={t('General.OrderBy')}
            fullWidth
            value={selectedVerificationOrder.id}
            onChange={onVerificationSorterChanged}
            labelKey='name'
            valueKey='id'
            simpleValue={true}
            options={verificationSorterOptions}
            isClearable={false}
            isSearchable={false}
          />
        </Grid>
        <Grid item container xs={3} justifyContent='end' gap={1}>
          <IconButton onClick={onVerificationsClick} id={'folder_decision_externalChecksCard_verifications'} variant='text' color='primary'>
            <DoneAll />
          </IconButton>
          <Link component='button' fontWeight='bold' onClick={onVerificationsClick}>
            {t('Placeholders.Verifications')}
          </Link>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

FolderExternalChecksItemSummaryToolbarComponent.propTypes = {
  onFilterValueChanged: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  onVerificationsClick: PropTypes.func.isRequired,
  onVerificationSorterChanged: PropTypes.func.isRequired,
  verificationSorterOptions: PropTypes.array.isRequired,
  selectedVerificationOrder: PropTypes.object.isRequired
};

export default FolderExternalChecksItemSummaryToolbarComponent;
